import EmptyState from "ds/components/EmptyState";
import Box from "ds/components/Box";
import { EmptystateUsersColored } from "components/icons/generated";
import { AccessResult } from "utils/access";
import PermissionGateButton from "components/PermissionGate/Button";
import DocumentationButton from "components/DocumentationButton";
import { getDocsUrl } from "utils/getDocsUrl";
import { AnalyticsPageStack } from "hooks/useAnalytics/pages/stack";

type StackRolesEmptyProps = {
  onManageRoles: () => void;
  canManage: AccessResult;
};

const StackRolesEmpty = ({ onManageRoles, canManage }: StackRolesEmptyProps) => {
  return (
    <EmptyState
      title="No roles assigned yet"
      caption="Grant roles to allow this stack to manage resources in other spaces."
      // TODO: Change to proper stack roles empty state icon once added to generated icons
      icon={EmptystateUsersColored}
      announce
    >
      <Box direction="row" gap="medium">
        <DocumentationButton
          to={getDocsUrl("/concepts/authorization/assigning-roles-stacks")}
          label="Documentation"
          analyticsPage={AnalyticsPageStack.StackSettingsRoles}
          analyticsTitle="Empty state - Documentation Clicked"
        />
        <PermissionGateButton access={canManage} variant="primary" onPress={onManageRoles}>
          Manage roles
        </PermissionGateButton>
      </Box>
    </EmptyState>
  );
};

export default StackRolesEmpty;
